import React from "react";
import { Outlet } from "react-router-dom";

const Legal = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Legal;
